import { createContext, ReactNode, useContext } from "react";

import { useFilterPackage } from "./filter-package.hook";

const FilterPackageContext = createContext(
  {} as ReturnType<typeof useFilterPackage>
);
export function useFilterPackageContext() {
  return useContext(FilterPackageContext);
}

interface FilterPackageProviderProps {
  children: ReactNode;
}
export function FilterPackageProvider({
  children,
}: FilterPackageProviderProps) {
  return (
    <FilterPackageContext.Provider value={useFilterPackage()}>
      {children}
    </FilterPackageContext.Provider>
  );
}